module.exports = __webpack_public_path__ + "img/Mail_black.bfe95caa.svg";